module.exports = __webpack_public_path__ + "img/illutr-main.7ff7437f.svg";